import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { selectAppNft } from '../store/appSlice';
import BackButton from './BackButton';
import AmountSelection from './AmountSelection.js';
import PremiumAnt from './images/ANT.png'; // Default image for premium ants
import diamond from './images/Icon_Diamond.png';
import Tooltip from './Tooltip.js';

function calculateApy(level) {
  const apyValues = [
    5.1, 5.3, 5.6, 6, 7.5, // Levels 1-5
    8.1, 8.8, 9.6, 10.5, 12.5, // Levels 6-10
    13.6, 14.8, 16.1, 17.5, 20, // Levels 11-15
    21.6, 23.3, 25.1, 27, 30, // Levels 16-20
    32.1, 34.3, 36.6, 39, 42.5, // Levels 21-25
    45.1, 47.8, 50.6, 53.5, 57.5, // Levels 26-30
    60.6, 63.8, 67.1, 70.5, 75, // Levels 31-35
    78.6, 62.3, 86.1, 90, 95, // Levels 36-40
  ];

  if(level < 1 || level > apyValues.length) {
    return 0; // Default or error value
  }

  return apyValues[level - 1];
}


function WorkforceAssign({ goBack }) {
  const [selectedANTItem, setSelectedAntItem] = useState(null);
  const { nfts } = useSelector(selectAppNft);
  const [showAmountSelection, setShowAmountSelection] = useState(false);
  const [activeItem, setActiveItem] = useState(null);
  const [imageUri, setImageUri] = useState(null);

  const handleANTItemClick = (ant) => {
    setSelectedAntItem(ant); // Store the full ant information
    setImageUri(ant.metadata.image); // Store the image URI
    setActiveItem(ant.mint); // Highlight the active ANT
  };

const handleSelectButtonClick = () => {
  console.log("Selected ANT:", selectedANTItem); // Check if the correct ANT is logged
  setShowAmountSelection(true); // This should toggle the popup
};

const handleAmountSelectionClose = () => {
  setShowAmountSelection(false); // This should hide the popup
};

  const formatMint = (mint) => {
    if (!mint) return '';
    return `${mint.substring(0, 10)}...${mint.substring(mint.length - 10)}`;
  };

  const copyToClipboard = (text) => {
    if (!text) return;
    navigator.clipboard.writeText(text).then(() => {
      alert('Address copied to clipboard!');
    }, (err) => {
      console.error('Failed to copy address', err);
    });
  };

  const getProgressPercentage = () => {
    if (selectedANTItem && selectedANTItem.remainPotions !== undefined && selectedANTItem.level !== undefined) {
      return (selectedANTItem.remainPotions / (selectedANTItem.level + 1)) * 100;
    }
    return 0;  // Default to 0 if data is not sufficient
  };

  const progressPercentage = getProgressPercentage();

  return (
    <section id="nestwars-ants1">
      <div className="newui-container">
        <div className="platform-container">
          <div className="inventory-container">
            <div className="inventory-container-left">
              <BackButton goBack={goBack} title={"BACK TO WORKFORCE"} />
              <div className="inventory-items">
                {nfts.map((nft, index) => {
                  const isPremium = nft.metadata.name.includes("Premium");
                  return (
                    <div
                      key={index}
                      className={`inventory-item ${isPremium ? "item-premium" : "item-basic"} ${activeItem === nft.mint ? "active9" : ""}`} // Highlight active Ant
                      onClick={() => handleANTItemClick(nft)}
                    >
                      <img src={nft.metadata.image} alt={nft.metadata.name} />
                      <div className="inventory-item-texts">
                        <p className="inventory-text">{nft.metadata.name}</p>
                        <p className="inventory-level-text">LVL:</p>
                        <p className="inventory-text">{nft.level}</p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            {showAmountSelection && (
              <AmountSelection
                onClose={handleAmountSelectionClose} // Correctly passes the closing function
                selectType="Workforce-Stake" // Ensure this is correct
                antInfo={activeItem} // Pass full ANT information
                imageUri={imageUri} // Pass the correct image URI
                AntCoinBalance={20230}
              />
            )}
            <div className="inventory-container-right">
              {selectedANTItem ? (
                <>
                  <div className="active-item-header-content-activity" id="ant-header-activity">
                    <div className="inventory-item-active-activity antonright-activity"><img src={selectedANTItem.metadata?.image || PremiumAnt} alt={selectedANTItem.name}/></div>
                    <div className="active-item-header-activity">
                      <h2>WORKER ANT</h2>
                     <p id="w-address" style={{ cursor: 'pointer' }} onClick={() => copyToClipboard(selectedANTItem.mint)}>{formatMint(selectedANTItem.mint)}</p>
                    </div>
                  </div>
                  <div className="level-bar-container" id="level-bar-leveling">
                  <div className="level-bar">
      <div className="level-indicator">
      LVL: <span className="bold-text">{selectedANTItem.level}</span>
      </div>
      <div className="exp-bar-container">
        <div 
          className="exp-bar" 
          style={{ width: `${progressPercentage}%` }}
        ></div>
      </div>
      <div className="exp-info">
        EXP:<span className="bold-text"> {selectedANTItem.remainPotions}/{selectedANTItem.level+1}</span>
      </div>
    </div>
    </div>
                  <div className="active-item-ant-container-activity2">
                    <div className="active-item-stats-activity-2"><h2>APY</h2><img src={diamond}></img><p>{calculateApy(selectedANTItem.level)}%</p></div>
                  </div>
                    <div className="active-item-buttons-container-activity">
                      <button className="active-item-button-lower" id="basic-ant-button-assign" onClick={handleSelectButtonClick}>ASSIGN ANT</button>
                    </div>
                </>
              ) : (
                <h2 className="inventory-info-text">Choose an ANT to get more info</h2>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default WorkforceAssign;